import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import SyncIcon from "@material-ui/icons/Sync";
import { REGISTER_SERVICE_SIGNLE } from "app/appConfig";
import CommonButton from "app/common/Component/Button/CommonButton";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import {
  isAdmin,
  isDoctor,
  isRoleBranchManager,
  isRoleCashier,
  isRoleHisAccountant,
  isRoleHisReadOnly,
} from "app/common/LocalFunction";
import { useStore } from "app/stores";
import { Form, Formik } from "formik";
import { observer } from "mobx-react";
import { memo, useState } from "react";
import RegisterServiceAdvicePopup from "./Popup/RegisterServiceAdvicePopup";
import RegisterServicePopup from "./Popup/RegisterServicePopup";
import RegisterTreatmentPlanAdvicePopup from "./Popup/RegisterTreatmentPlanAdvicePopup";
import RegisterTreatmentPlanPopup from "./Popup/RegisterTreatmentPlanPopup";
import RegisterServiceIndex from "./Service/RegisterServiceIndex";
import RegisterTreatmentPlanIndex from "./TreatmentPlan/RegisterTreatmentPlanIndex";

const RegisterProductTabsIndex = () => {
  const {
    handleOpenCreateOrEditServicePopup,
    handleOpenAddServiceAdvicePopup,
    openAddServiceAdvicePopup,
    handleCloseAddServiceAdvicePopup,
    resetPopupStore,
    dataRegisterService,
    saveOrUpdateServiceAdvice,
    openUpdateServiceAdvicePopup,
    handleCloseUpdateServiceAdvicePopup,
    initRegisterService,
    pagingRegisterService,
    pageRegisterService,
    searchListPaServiceRes,
    handleChangeFormSearchServiceAdvice,
  } = useStore().patientManagementStore.registerServiceStore;

  const {
    handleOpenCreateOrEditTreatmentPlanPopup,
    pagingRegisterTreatmentPlan,
    dataRegisterTreatmentPlan,
    handleCloseAddTreatmentPlanAdvicePopup,
    handleOpenAddTreatmentPlanAdvicePopup,
    openAddTreatmentPlanAdvicePopup,
    saveOrUpdateTreatmentPlanAdvice,
    openUpdateTreatmentPlanAdvicePopup,
    initRegisterTreatmentPlan,
    handleCloseUpdateTreatmentPlanAdvicePopup,
    handleInitPaymentVoucherPopup,
    handleChangeFormSearchTreatmentPlanAdvice,
    searchListTreatmentPlanAdvice,
  } = useStore().patientManagementStore.registerTreatmentPlanStore;
  const isAdmins = isAdmin();
  const isRoleBranchManagers = isRoleBranchManager();
  const isAccountant = isRoleHisAccountant();
  const isCashier = isRoleCashier();
  const canAdd = isAdmins || isRoleBranchManagers || isAccountant || isCashier;
  const defaultDepartment = useDefaultDepartment();

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorTreatmentPlanEl, setAnchorTreatmentPlanEl] = useState(null);
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  const isDocters = isDoctor();
  const isReadonly = isRoleHisReadOnly();
  const { initialPatient, listVatPercent, customerSourceWalkIn } =
    useStore().patientManagementStore.patientGeneralStore;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} className="mr-2  mt-2">
        <Formik enableReinitialize initialValues={{ orderDate: new Date() }}>
          {({ values }) => {
            return (
              <Form autoComplete="off">
                <Grid container spacing={1}>
                  {isMobile && (
                    <>
                      <Grid item xs={6} md={2}>
                        <GlobitsDateTimePicker
                          name={"orderDate"}
                          label="Ngày tư vấn"
                          maxDateMessage="Ngày tư vấn phải trước ngày hiện tại"
                          maxDate={new Date()}
                          // isDateTimePicker
                        />
                      </Grid>
                      <Grid item xs={6} md={6}>
                        {canAdd && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "end",
                              height: "100%",
                            }}
                          >
                            {REGISTER_SERVICE_SIGNLE && (
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                }}
                              >
                                <CommonButton
                                  className="btn-add"
                                  onClick={async (e) => {
                                    setAnchorEl(anchorEl ? null : e.target);
                                    setAnchorTreatmentPlanEl(null);
                                  }}
                                  style={{
                                    position: "relative",
                                    height: "100%",
                                  }}
                                >
                                  <Add />
                                  Dịch vụ
                                </CommonButton>

                                {anchorEl && (
                                  <div
                                    className="popover-list"
                                    style={{
                                      right: 0,
                                      left: "auto",
                                      position: "absolute",
                                      minWidth: "160px",
                                    }}
                                  >
                                    <div
                                      className="popover-item popover-item-custom"
                                      style={{ color: "#4276a4" }}
                                      onClick={() => {
                                        handleOpenCreateOrEditServicePopup();
                                        setAnchorEl(null);
                                      }}
                                    >
                                      <AddCircleOutlineIcon
                                        fontSize="small"
                                        className="icon"
                                      />
                                      Thêm
                                    </div>
                                    <div
                                      className="popover-item"
                                      style={{ color: "#4276a4" }}
                                      onClick={() => {
                                        handleOpenAddServiceAdvicePopup({
                                          orderDate: values?.orderDate,
                                          patientId,
                                        });
                                        setAnchorEl(null);
                                      }}
                                    >
                                      <SyncIcon
                                        fontSize="small"
                                        color="#007b8f"
                                        className="icon"
                                      />
                                      Lấy từ tư vấn
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                            {canAdd && (
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                }}
                              >
                                <CommonButton
                                  className="btn-add"
                                  onClick={async (e) => {
                                    setAnchorTreatmentPlanEl(
                                      anchorTreatmentPlanEl ? null : e.target
                                    );
                                    setAnchorEl(null);
                                  }}
                                  style={{
                                    position: "relative",
                                    height: "100%",
                                  }}
                                >
                                  <Add />
                                  Liệu trình
                                </CommonButton>
                                {/* <Tooltip title={"In dịch vụ lẻ - thẻ - liệu trình - sản phẩm"}>
                            <Button
                              onClick={() => {
                                handleOpenPopupPrintAll(patientId);
                              }}
                              className="btn-add"
                              style={{ position: "relative", height: "100%", marginLeft:"6px" }}
                            >
                              <PrintIcon />
                              In tất cả phiếu
                            </Button>
                          </Tooltip> */}
                                {anchorTreatmentPlanEl && (
                                  <div
                                    className="popover-list"
                                    style={{
                                      right: 0,
                                      left: "auto",
                                      position: "absolute",
                                      minWidth: "160px",
                                    }}
                                  >
                                    <div
                                      className="popover-item popover-item-custom"
                                      style={{ color: "#4276a4" }}
                                      onClick={() => {
                                        handleOpenCreateOrEditTreatmentPlanPopup(
                                          null,
                                          initialPatient?.patientInfo,
                                          customerSourceWalkIn,
                                          defaultDepartment
                                        );
                                        setAnchorTreatmentPlanEl(null);
                                      }}
                                    >
                                      <AddCircleOutlineIcon
                                        fontSize="small"
                                        className="icon"
                                      />
                                      Thêm
                                    </div>
                                    <div
                                      className="popover-item"
                                      style={{ color: "#4276a4" }}
                                      onClick={() => {
                                        handleOpenAddTreatmentPlanAdvicePopup({
                                          orderDate: values?.orderDate,
                                          patientId,
                                        });
                                        setAnchorTreatmentPlanEl(null);
                                      }}
                                    >
                                      <SyncIcon
                                        fontSize="small"
                                        color="#007b8f"
                                        className="icon"
                                      />
                                      Lấy từ tư vấn
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </Grid>
                    </>
                  )}
                </Grid>
                {REGISTER_SERVICE_SIGNLE && (
                  <Grid item xs={12}>
                    <RegisterServiceIndex />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <RegisterTreatmentPlanIndex values={values} />
                </Grid>
              </Form>
            );
          }}
        </Formik>
      </Grid>

      {/*popup dịch vụ */}
      {!!openUpdateServiceAdvicePopup && (
        <RegisterServicePopup
          open={!!openUpdateServiceAdvicePopup}
          handleClose={handleCloseUpdateServiceAdvicePopup}
          onSubmit={async (values) => {
            await saveOrUpdateServiceAdvice(values);
            // handleCloseUpdateServiceAdvicePopup();
          }}
          initRegisterService={{ ...initRegisterService, patientId }}
          listVatPercent={listVatPercent}
          resetPopupStore={resetPopupStore}
        />
      )}
      {!!openAddServiceAdvicePopup && (
        <RegisterServiceAdvicePopup
          open={!!openAddServiceAdvicePopup}
          handleClose={() => {
            handleCloseAddServiceAdvicePopup();
            pagingRegisterService();
          }}
          onSubmit={handleChangeFormSearchServiceAdvice}
          dataRegisterService={dataRegisterService}
          listVatPercent={listVatPercent}
          initialData={searchListPaServiceRes}
          patient={initialPatient?.patientInfo}
          customerSourceWalkIn={customerSourceWalkIn}
        />
      )}

      {/*popup liệu trình */}

      {!!openUpdateTreatmentPlanAdvicePopup && (
        <RegisterTreatmentPlanPopup
          open={!!openUpdateTreatmentPlanAdvicePopup}
          handleClose={handleCloseUpdateTreatmentPlanAdvicePopup}
          onSubmit={async (values) => {
            await saveOrUpdateTreatmentPlanAdvice(values);
          }}
          initRegisterTreatmentPlan={{
            ...initRegisterTreatmentPlan,
            patientId,
          }}
          listVatPercent={listVatPercent}
          resetPopupStore={resetPopupStore}
          customerSourceWalkIn={customerSourceWalkIn}
          handleInitPaymentVoucherPopup={handleInitPaymentVoucherPopup}
          patient={initialPatient?.patientInfo}
        />
      )}

      {!!openAddTreatmentPlanAdvicePopup && (
        <RegisterTreatmentPlanAdvicePopup
          open={!!openAddTreatmentPlanAdvicePopup}
          handleClose={() => {
            handleCloseAddTreatmentPlanAdvicePopup();
            pagingRegisterTreatmentPlan();
          }}
          dataRegisterTreatmentPlan={dataRegisterTreatmentPlan}
          patient={initialPatient?.patientInfo}
          customerSourceWalkIn={customerSourceWalkIn}
          onSubmit={handleChangeFormSearchTreatmentPlanAdvice}
          initialData={searchListTreatmentPlanAdvice}
        />
      )}
      {/* {openPopupPrintAll && (
        <PopupPrintAllTab
          open={openPopupPrintAll}
          handleClose={() => {
          handleClosePrintTreatmentPlan()
          }}
        />
      )} */}
    </Grid>
  );
};

export default memo(observer(RegisterProductTabsIndex));
